import React from 'react';
import { noop, pick, getNamespace } from './utils';


function withSessionStorage(WrapperComponent, options) {
  const keysToSync = WrapperComponent.sessionStorageKeys;

  function sessionStorageMiddleWare(callback, _this) {
    const stateObj = pick(_this.state, keysToSync);
    const namespace = getNamespace(WrapperComponent, _this);
    try {
      sessionStorage.setItem(namespace, JSON.stringify(stateObj));
    } catch (e) {
      console.error(e);
    }
    callback.call(_this);
  }

  return class SessionStorageWrapper extends React.Component {
    getStateFromSessionStorage(reference) {
      const namespace = getNamespace(WrapperComponent, reference);
      return (
        JSON.parse(sessionStorage.getItem(namespace))
      );
    }

    setUp(ref) {
      const originalSetState = ref.setState;

      // Override child's setState
      ref.setState = function (stateObj, callback = noop) {
        originalSetState.call(
          // Preserve this for setState
          ref,
          // Merge the original stateObject
          stateObj,
          // Call custom middleware that syncs with sessionStorage and
          // call the callback if any
          sessionStorageMiddleWare.bind(this, callback, ref)
        );
      }
    }

    render() {
      return (
        <WrapperComponent
          getStateFromSessionStorage={this.getStateFromSessionStorage}
          ref={this.setUp}
        />
      );
    }
  }
}

export default withSessionStorage;
